import { SvgIcon } from '@mui/material';
import React from 'react';

const OrderIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="Calque_1"
        data-name="Calque 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 176.82 150.01"
        strokeWidth={0}
        fill="currentColor"
      >
        <path d="m145.89,56.52v88.49c0,2.76-2.23,4.99-4.99,4.99H35.92c-2.76,0-4.99-2.23-4.99-4.99V56.52c0-2.76,2.23-4.99,4.99-4.99h28.61v53.17c0,10.16,8.24,18.4,18.4,18.4h11.07c10.13,0,18.39-8.25,18.39-18.4v-53.17h28.52c2.76,0,4.99,2.23,4.99,4.99Z" />
        <path d="m120.92,37.71h-21.65v67c0,2.88-2.38,5.26-5.26,5.26h-11.08c-2.91,0-5.26-2.38-5.26-5.26V37.71h-21.79c-2.83,0-4.23-3.44-2.22-5.42l9.12-8.99L85.01,1.43c.95-.95,2.19-1.43,3.44-1.43s2.51.48,3.44,1.43l22.26,21.87,9.02,8.91c2.06,2.01.63,5.5-2.25,5.5Z" />
      </svg>
    </SvgIcon>
  );
};

export default OrderIcon;
